export default "__VITE_ASSET__DGhYUm7Z__"